import { useState } from 'react';
import { UserWithRole, PanelAccess, PanelSection } from '../../../../shared/services/userService';
import userService from '../../../../shared/services/userService';

export const usePanelAccessManagement = () => {
  const [panelAccess, setPanelAccess] = useState<PanelAccess[]>([]);
  const [panelSections, setPanelSections] = useState<PanelSection[]>([]);
  const [loading, setLoading] = useState(false);
  const [updating, setUpdating] = useState(false);

  const loadPanelAccess = async (user: UserWithRole) => {
    try {
      setLoading(true);
      const [accessResponse, sectionsResponse] = await Promise.all([
        userService.getUserPanelAccess(user.id),
        userService.getPanelSections()
      ]);
      
      if (accessResponse.success && sectionsResponse.success) {
        setPanelAccess(accessResponse.data);
        setPanelSections(sectionsResponse.data);
        return true;
      }
      return false;
    } catch (err) {
      return false;
    } finally {
      setLoading(false);
    }
  };

  const toggleAccess = async (
    userId: number,
    section: string,
    hasAccess: boolean,
    grantedBy: string
  ) => {
    try {
      setUpdating(true);
      const response = await userService.updateUserPanelAccess(
        userId,
        section,
        hasAccess,
        `Accès ${hasAccess ? 'accordé' : 'refusé'} par ${grantedBy}`
      );

      if (response.success) {
        const updatedAccess = [...panelAccess];
        const index = updatedAccess.findIndex(a => a.section === section);
        if (index >= 0) {
          updatedAccess[index] = response.data;
        } else {
          updatedAccess.push(response.data);
        }
        setPanelAccess(updatedAccess);
        return response.data;
      }
    } catch (err: any) {
      throw err;
    } finally {
      setUpdating(false);
    }
  };

  const getSectionAccess = (sectionId: string): boolean => {
    const access = panelAccess.find(a => a.section === sectionId);
    return access ? access.has_access : true;
  };

  const reset = () => {
    setPanelAccess([]);
    setPanelSections([]);
  };

  return {
    panelAccess,
    panelSections,
    loading,
    updating,
    loadPanelAccess,
    toggleAccess,
    getSectionAccess,
    reset,
  };
};

